module.exports = __webpack_public_path__ + "img/burshtat_mob_portfolio_2_mob.206218ec.png";